import { LEADERBOARD_TABS_REQUEST, LEADERBOARD_TABS_SUCCESS, LEADERBOARD_TABS_FAILURE } from './types'
import axiosInstance from '../../utils/api'

export const fetchLeaderboardRequest = () => {
  return {
    type: LEADERBOARD_TABS_REQUEST,
  }
}
export const fetchLeaderboardSuccess = (data) => {
  return {
    type: LEADERBOARD_TABS_SUCCESS,
    payload: data,
  }
}
export const fetchLeaderboardFailure = (error) => {
  return {
    type: LEADERBOARD_TABS_FAILURE,
    payload: error,
  }
}

export const getLeaderboardTabs = () => async (dispatch) => {
  dispatch(fetchLeaderboardRequest())
  await axiosInstance
    .get(`/api/admin/lbtab`)
    .then((response) => {
      const result = response.data
      dispatch(fetchLeaderboardSuccess(result))
    })
    .catch((error) => {
      const errorMsg = error.message
      dispatch(fetchLeaderboardFailure(errorMsg))
    })
}
